import React from 'react'
import styles from './ExportTRouteModal.scss'
import {ModalOverlay} from 'common/styleguide/ModalOverlay'
import {contentLabel} from 'lib/styleguide/base.scss'
import {ExportFormats} from 'common/ExportFormats'

export const EXPORT_TROUTE_MODAL = 'EXPORT_TROUTE_MODAL'

export class ExportTRouteModal extends React.PureComponent {
  render () {
    const {troute, objectType, onRequestClose} = this.props

    return (
      <ModalOverlay
        title={<span>Export <strong>{troute.name}</strong></span>}
        maxWidth='400px'
        onRequestClose={onRequestClose}>
        <div className={styles.ExportTRouteModal}>
          <h2 className={contentLabel} style={{marginBottom: '15px'}}>File Formats</h2>
          <div style={{marginBottom: '40px'}}>
            <ExportFormats
              troute={troute}
              objectType={objectType} />
          </div>
          <p className={styles.help}>
            Not sure which format you need? Our <a href='https://ridewithgps.com/help/export-file-formats' target='_blank'>help page</a>
            {' '}has detailed information about compatibility with a variety of programs and devices
          </p>
        </div>
      </ModalOverlay>
    )
  }
}
